import {
 
  REALTIME_TRIPS_REQUEST,
  REALTIME_TRIPS_SUCCESS,
  REALTIME_TRIPS_FAIL,
  REALTIME_TRIPS_RESET,

  REALTIME_SPEED_REQUEST,
  REALTIME_SPEED_SUCCESS,
  REALTIME_SPEED_FAIL,
  REALTIME_SPEED_RESET,



} from "../constants/realtimeConstants";

export const realtimeTripsReducer = (
  state = { loading: false, data:   []  },
  action
) => {
  switch (action.type) {
    case REALTIME_TRIPS_REQUEST:
      return {
        ...state,
        loading: true,
        status:"loading"
      };

    case REALTIME_TRIPS_SUCCESS:
      return {
        loading: false,
        data: action.payload,
         status:"success",
      };

    case REALTIME_TRIPS_FAIL:
      return {
        data:  [],
        loading: false,
        error: action.payload,
        status:"error"
      };
    case REALTIME_TRIPS_RESET:
      return { loading: false, data:  [], status:"reset"  };

    default:
      return state;
  }
};


export const realtimeSpeedReducer = (
  state = { loading: false, data:   {}  },
  action
) => {
  switch (action.type) {
    case REALTIME_SPEED_REQUEST:
      return {
        ...state,
        loading: true,
        status:"loading"
      };

    case REALTIME_SPEED_SUCCESS:
      return {
        loading: false,
        data: action.payload,
         status:"success",
      };

    case REALTIME_SPEED_FAIL:
      return {
        data:  {},
        loading: false,
        error: action.payload,
        status:"error"
      };
    case REALTIME_SPEED_RESET:
      return { loading: false, data:  {}, status:"reset"  };

    default:
      return state;
  }
};

